import gql from 'graphql-tag';
const credential = gql`
  fragment credential on BaseCredential {
    credentialInfo {
      name
      values
    }
  }
`;
export const profile = gql`
  fragment profile on Profile {
    workHistory {
      achievements
      company {
        text
      }
      startDate {
        month
        year
      }
      endDate {
        month
        year
      }
      id
      title {
        text
      }
    }
    education {
      id
      name {
        text
      }
      completed
      completionDate {
        year
        month
      }
      highlights
      institute {
        text
      }
      credential {
        ...credential
      }
    }
    licences {
      description
      expiryDate {
        month
        year
      }
      formattedExpiryDate
      credential {
        ...credential
      }
      id
      issueDate {
        month
        year
      }
      issuingOrganisation
      name {
        text
      }
      noExpiryDate
      origin
    }
    skills {
      keyword {
        text
      }
    }
    rightsToWork {
      answer
      country
    }
    expectedSalaries {
      salaryType
      minimumSalaryValue
      maximumSalaryValue
      currency
    }
    verifiedIdentity {
      fullName
    }
    homeLocation {
      description(input: $homeLocationDescriptionInput)
      id
    }
  }
  ${credential}
`;
